import { useMutation } from "@tanstack/react-query";
import {
  createClaimTypesAPI,
  deleteClaimTypesAPI,
  updateClaimTypesAPI,
} from "./claimTypes.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddClaimTypesMutation = () => {
  return useMutation({
    mutationFn: createClaimTypesAPI,
    onError: handleNetworkError,
  });
};

const useUpdateClaimTypesMutation = () => {
  return useMutation({
    mutationFn: updateClaimTypesAPI,
    onError: handleNetworkError,
  });
};

const useDeleteClaimTypesMutation = () => {
  return useMutation({
    mutationFn: deleteClaimTypesAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddClaimTypesMutation,
  useUpdateClaimTypesMutation,
  useDeleteClaimTypesMutation,
};
